<template>
  <div>
    <answer-tile :question="question" :key="question.id"></answer-tile>
  </div>
</template>

<script>
import AnswerTile from './AnswerTile';

export default {
  components: {
    AnswerTile
  },
  name: 'question-list',
  props: ['question'],
  computed: {}
};
</script>

<style scoped lang="scss"></style>
